// Built-in slugs mirror builtin_roles.rs and shared-rbac RoleName.
// Labels are dashboard copy; update this catalog when backend roles change.
export const ROLE_CATALOG = [
    { slug: "tenant-admin",         label: "Tenant Admin",         description: "Manages users, endpoints, integrations, and tenant settings." },
    { slug: "sec-ops",              label: "SecOps",               description: "Manages alert dispositions, saved views, and personal chats. When ABAC is off, can read activity metadata, excluding prompt content and sensitive data." },
    { slug: "detection-engineer",   label: "Detection Engineer",   description: "Manages alert dispositions, saved views, and personal chats. When ABAC is off, can also read raw events and AI traces." },
    { slug: "it-ops",               label: "IT / Fleet Admin",     description: "Manages the endpoint fleet. When ABAC is off, has no access to raw event content." },
    { slug: "viewer",               label: "Viewer",               description: "Read-only operational access for auditors and stakeholders. When ABAC is off, can read activity metadata." },
    { slug: "vendor-support",       label: "Vendor Support",       description: "Read-only operational access for support. When ABAC is off, can also read prompt content and sensitive data." },
    { slug: "security-engineering", label: "Security Engineering", description: "Manages integrations and platform configuration. When ABAC is off, has no access to monitored data." },
    { slug: "no-data-access",       label: "No Data Access",       description: "Can sign in and navigate without operational permissions. When ABAC is off, has no activity access." },
];

const ROLE_BY_SLUG = Object.fromEntries(ROLE_CATALOG.map((r) => [r.slug, r]));

export function roleLabel(slug) {
    return ROLE_BY_SLUG[slug]?.label ?? slug ?? "Unknown role";
}

export const ROLE_ACTIVITY_ACCESS_NOTE = "When ABAC is on, separate grants determine access to activity metadata and prompt/response content. When ABAC is off, the role's data permissions apply.";

// The membership role /v1/me names while the permission posture loads, in
// words: TENANT_ROLE_ADMIN is "Admin".
export function membershipRoleLabel(role) {
    const word = String(role || "").replace(/^TENANT_ROLE_/, "").replace(/_/g, " ").toLowerCase();
    return word ? word[0].toUpperCase() + word.slice(1) : "";
}

// The reader's role(s) in words: the posture's roles once known, else the
// membership role.
export function signedInRole(roleSlugs, membershipRole) {
    return roleSlugs.length ? roleSlugs.map(roleLabel).join(", ") : membershipRoleLabel(membershipRole);
}
